import request from '@/utils/request'

let CertApi = {

  /*证书列表*/
  list(data) {
    return request._post('/shop/plus.cert.Index/index', data);
  },
  /*添加证书*/
  add(data) {
      return request._post('/shop/plus.cert.Index/add', data);
  },
  /*修改证书*/
  edit(data) {
      return request._post('/shop/plus.cert.Index/edit', data);
  },
  /*删除证书*/
  del(data) {
      return request._post('/shop/plus.cert.Index/del', data);
  },
  /*证书详情*/
  detail(data) {
    return request._post('/shop/plus.cert.Index/detail', data);
  },
  /*生成图片*/
  gen(data) {// api/plus.agent.qrcode/poster
    return request._post('/shop/plus.agent.qrcode/genCert', data);
  },
    /*设置默认*/
    setPageDefault(data){
      return request._post('/shop/plus.cert.Index/setPageDefault', data);
    },
      /*获取等级*/
      getGrade(data){
        return request._post('/shop/plus.cert.Index/getGrade', data);
      },
}
export default CertApi;



// WEBPACK FOOTER //
// ./src/api/cert.js